import React from 'react';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";

const Solicitud = ({ mt15, solicitud, parentescos, index }) => {
    return (
        <>
            <Col style={mt15} xs={isBrowser ? 4 : 12}>
             <strong> Nombre: </strong> { solicitud.nombreEmpleado }
            </Col>

            <Col style={mt15} xs={isBrowser ? 4 : 12}>
                <strong> Relación: </strong> { parentescos.find(x => x.id === solicitud.parentescoId)?.nombre }
            </Col>

            <Col style={mt15} xs={isBrowser ? 4 : 12}>
                <strong> ¿Es familiar? </strong> { solicitud.familia ? 'Sí' : 'No' }
            </Col>
        </>
    );
};

export default (Solicitud);